import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollHandler = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Retry finding the element a few times in case of lazy loading or slow rendering
      let attempts = 0;
      const maxAttempts = 10;

      const scrollToHash = () => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);

        if (element) {
          const headerOffset = 100; // Account for fixed navbar
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.scrollY - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(scrollToHash, 100);
        }
      };

      scrollToHash();
    }
  }, [pathname, hash]);

  return null;
};
